import { fetchRegion, useI18N } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import WineFactsPresentational from './WineFacts.presentational';
import { getWineFacts } from './helpers/wineFacts';

const WineFacts = ({ vintage }) => {
  const { t } = useI18N();
  const [facts, setFacts] = useState(getWineFacts(vintage, t) || []);

  useEffect(() => {
    const regionId = vintage.wine?.region?.id;
    if (regionId) {
      // this API call will fetch more richer region data
      // including parent regions data which is not available in `wine.region`
      fetchRegion(regionId)
        .then(({ region }) => {
          const decoratedVintage = {
            ...vintage,
          };
          decoratedVintage.wine.region = region;
          setFacts(getWineFacts(decoratedVintage, t));
        })
        .catch(() => {
          // this is only a nice-to-have data, so just ignore
        });
    }
  }, []);

  return <WineFactsPresentational facts={facts} />;
};

WineFacts.propTypes = {
  vintage: PropTypes.object.isRequired,
};

export default WineFacts;
